
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';

@Component({
    name: 'QrcodePopup',
})
export default class QrcodePopup extends Vue {
    /** 二维码弹窗 */
    public popupVisible: boolean = false;
    /** 默认不勾选 */
    public neverDisplay: boolean = false;

    /** 二维码是否可见 */
    public get visible() {
        return store.state.util.popup.visible;
    }
    /** 二维码链接 */
    public get popup() {
        return store.state.util.popup;
    }

    @Watch('visible')
    public onVisibleChange(val: boolean) {
        this.popupVisible = val;
    }

    /**
     * 点击关闭
     */
    public onClickCloseQrcode() {
        this.popupVisible = false;
        store.commit('setPopupVisible', false);
        // 调用callback
        if (this.popup.closeCb) {
            this.popup.closeCb({ neverDisplay: this.neverDisplay });
        }
        // 充值neverDisplay
        this.neverDisplay = false;
    }
    public onClickNeverDisplay() {
        this.neverDisplay = !this.neverDisplay;
    }
}
